// AI请求用户类型
export enum EAiReqUserType {
    USER = 'user',
    SERVICE = 'service'
}

// AI聊天角色
export enum EAiChatRoleType {
    USER = 'user',
    AI = 'assistant'
}

// AiAgent返回类型
export enum EAiAgentType {
    HEALTH_KEEPER = 'health_keeper',
    SALES_ASSISTANT = 'sales_assistant',
    CUSTOMER_SERVICE = 'customer_service',
    HUMAN_SERVICE = 'human_service',
    CALL_SERVICE = 'call_service'
}

// 商品类型
export enum ECommodityType {
    PHY_EXAM = '体检',
    IMAGE = '影像'
}